import React, { FC } from "react";
import { LinkProps, StyledLink as BaseStyledLink } from "baseui/link";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export const StyledLink: FC<LinkProps> = ({ children, ...props }) => {
  const [, theme] = useStyletron();
  return (
    <BaseStyledLink
      style={{
        color: theme.colors.linkText,
        textDecoration: "none",
        ":hover": {
          textDecoration: "none",
        },
      }}
      {...props}
    >
      {children}
    </BaseStyledLink>
  );
};
